import { Component, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { DatePipe, Location } from "@angular/common";
import {
  AGENDA_SOLUTIONS_APPROVE,
  API_URL_GET_DETAIL_AGENDA_NEEDS,
} from "manager/http-constants";
import { MESSAGE_CODE } from "src/app/shared/constant/message-constant";
import { TOAST } from "src/app/shared/constant/primeng-constants";
import { LoadingState } from "src/app/shared/html-parts/loading/loading-state";
import {
  MessageData,
  ToastMessageData,
} from "src/app/shared/html-parts/message-common/message-data";
import { CommonService } from "src/app/shared/service/common.service";
import { DbOperationService } from "src/app/shared/service/db-operation.service";
import { PlatformComponent } from "../platform.component";
import { ApprovalDialogComponent } from "../common/approval-dialog/approval-dialog.component";
import { LoginService } from "src/app/shared/service/login.service";
import { MATCH_TYPE } from "src/app/shared/constant/constant";

@Component({
  selector: "app-c3341",
  templateUrl: "./c341.component.html",
  styleUrls: ["./c341.component.scss", "../platform.component.scss"],
})

/**
 * 課題・ソリューション詳細
 */
export class C341Component extends PlatformComponent {
  /** 共通部品_承認時ダイアログ */
  @ViewChild(ApprovalDialogComponent)
  approvalDialogComponent: ApprovalDialogComponent;

  // 課題ID
  agendaId: string = this.route.snapshot.params.agenda_id;

  // 課題・ソリューション詳細格納先
  detailTask: any;

  // マッチング依頼一覧格納先
  matchingList: any;

  // 質問掲示板の件数格納先
  countQuestionBoard: number = 0;
  class_id: any;
  // variable to show content
  isDataLoaded: boolean = false;
  constructor(
    public route: ActivatedRoute,
    public commonService: CommonService,
    public dbOperationService: DbOperationService,
    public loadingState: LoadingState,
    private router: Router,
    private messageData: MessageData,
    private location: Location,
    private datePipe: DatePipe,
    public loginService: LoginService
  ) {
    super(route, commonService, dbOperationService, loadingState, loginService);
  }

  async ngOnInit(): Promise<void> {
    this.loadingState.loadStart();
    if (await this.loginService.checkLoginUser()) {
      this.class_id = this.loginService.getCurrentUser().class_id;
      // // 課題・ソリューション詳細を取得
      this.getDetailTask();
    }else{
      this.loginService.logout(MESSAGE_CODE.E90000);
    }
    this.loadingState.loadSleepEnd(0.3);
  }

  /**
   * 課題・ソリューション詳細を取得
   */
  public getDetailTask(): void {
    // 画面ロードフラグをON(ロード中状態)
    this.loadingState.loadStart(API_URL_GET_DETAIL_AGENDA_NEEDS);

    // 課題・ソリューション詳細を取得
    this.dbOperationService
      .getNoTemplateDisplayData(API_URL_GET_DETAIL_AGENDA_NEEDS, this.agendaId)
      .subscribe((response) => {
        // 画面ロードフラグをOFF(ロード終了)
        this.loadingState.loadSleepEnd(0.3, API_URL_GET_DETAIL_AGENDA_NEEDS);

        if (this.commonService.checkInvalidValue(response)) {
          this.isDataLoaded = false;
          // 警告メッセージ
          this.messageData.toastMessage(
            new ToastMessageData({
              severity: TOAST.WARN,
              summary: this.commonService.msg(MESSAGE_CODE.E00003),
              detail: this.commonService.msg(MESSAGE_CODE.E00026),
            })
          );

          // 前画面へ戻る
          this.location.back();
        } else {
          this.isDataLoaded = true;
          // 課題・ソリューション詳細を格納
          this.detailTask = response.body;

          // 公開掲示板をデフォルトで表示
          // if (1 == this.detailTask?.board_open.id && this.decisionLoginState()) {
          //   this.moveChat()
          // }
        }
      });
  }

  /**
   * 課題・ソリューション登録(C101)へ遷移する
   */
  public moveC101(): void {
    // 課題・ソリューション登録(C101)へ遷移
    this.router.navigate(["pages/platform/c101/edit"], {
      queryParams: {
        screenId: "c101",
        agenda_id: this.route.snapshot.params.agenda_id,
        agenda_kbn: this.detailTask.agenda_kbn.id,
      },
    });
  }

  /**
   * マッチング提案掲示板(C601)へ遷移する
   * @param suggestId 提案ID
   */
  public moveC601(suggestId: string): void {
    // マッチング提案掲示板(C601)へ遷移
    this.router.navigate(["pages/platform/c601/" + suggestId], {
      queryParams: {
        agenda_id: this.route.snapshot.params.agenda_id,
      },
    });
  }

  /**
   * 内閣府承認ダイアログ表示
   */
  public openSmallApprovalDialog(): void {
    // 内閣府承認ダイアログ表示
    this.approvalDialogComponent.openSmallApprovalDialog(
      AGENDA_SOLUTIONS_APPROVE,
      this.agendaId,
      2003,
      0,
      1
    );
  }

  moveC241() {
    this.router.navigate(["pages/platform/c241/"]);
  }
  public moveC441(): void {
    this.router.navigate(["pages/platform/c401/new"], {
      queryParams: {
        screenId: "c401",
        agenda_id: this.route.snapshot.params.agenda_id,
        match_type: MATCH_TYPE.AGENDA_NEED,
      },
    });
  }
}
